module.exports = __webpack_public_path__ + "static/media/cloud3-blue-min.7219e616.png";